import { Dispatch } from 'redux';
import { createNewTypeOfView, modifyTypeOfView } from 'src/app/common/network/typeOfViewCrud';
import { ETypeOfView, ITypeOfView } from 'src/app/common/types/view-types';

export interface TypeOfViewFormData {
  typeOfViews?: ITypeOfView[];
}

export interface TypeOfViewInitialValues {
  typeOfViews?: ITypeOfView[];
}

export interface ResolvedTypeOfViewResult {
  typeOfViews: string[];
}

/**
 * Resolves typeOfView / typeOfViews for submit payloads.
 * Handles create, modify, and no-change cases for both single and multi-view modes.
 */
export const resolveTypeOfViewIds = async (
  formData: TypeOfViewFormData,
  initialValues: TypeOfViewInitialValues,
  selectedId: string,
  dispatch: Dispatch,
): Promise<ResolvedTypeOfViewResult> => {
  const result: ResolvedTypeOfViewResult = {
    typeOfViews: [],
  };

  if (formData?.typeOfViews && formData?.typeOfViews?.length > 0) {
    const initialViewsMap = new Map((initialValues.typeOfViews || []).map((item) => [item.id, item]));

    const viewPromises = formData.typeOfViews.map(async (typeOfViewItem) => {
      if (!selectedId || !typeOfViewItem.id) {
        const newViewType = await createNewTypeOfView(typeOfViewItem, dispatch);
        return newViewType?.id || null;
      }

      const initialItem = initialViewsMap.get(typeOfViewItem.id);
      const isGroupType = typeOfViewItem.type === ETypeOfView.GroupOfUsers;
      const isFileChanged = typeOfViewItem?.userFile?.id !== initialItem?.userFile?.id;

      if (isGroupType && isFileChanged) {
        const viewType = await modifyTypeOfView(typeOfViewItem.id, typeOfViewItem, dispatch);
        return viewType?.id || null;
      }

      const isTypeChanged = typeOfViewItem.type !== initialItem?.type;
      if (isTypeChanged) {
        const newViewType = await createNewTypeOfView(typeOfViewItem, dispatch);
        return newViewType?.id || null;
      }

      return typeOfViewItem.id;
    });

    const resolvedIds = await Promise.all(viewPromises);
    result.typeOfViews = resolvedIds.filter((id): id is string => Boolean(id));
  }

  return result;
};
